
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M39.941 7.235H25.823v14.118h14.118zM39.941 28.824H25.823V42.94h14.118zM18.353 28.824H4.235V42.94h14.118z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M41.941 5.235H27.823v14.118h14.118zM41.941 26.824H27.823V40.94h14.118zM20.353 26.824H6.235V40.94h14.118z"}})])
          )
        }
      }
    